/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { useState, useRef } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { createUser } from '../../actions/organizationActions';
import { updateFormError } from '../../actions/userActions';

const AddUser = ({
  organization,
  formError,
  teams,
  createUser,
  updateFormError
}) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const nameInput = useRef();
  let { errors } = formError;
  if (!errors) errors = {};

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const getRandomColor = () => {
    const n = (Math.random() * 0xfffff * 1000000).toString(16);
    return `#${n.slice(0, 6)}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email && errors) delete errors.email;
    else errors.email = ['Email is required.'];

    if (name && errors) delete errors.name;
    else errors.name = ['Name is required.'];

    if (isEmpty(errors)) {
      const initials = name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toLocaleUpperCase();
      const color = getRandomColor();
      const user = {
        name,
        email,
        initials,
        nickname: name,
        color,
        teams: teams.length === 1 ? teams : [],
        default_team: teams[0] ? teams[0] : null
      };
      createUser(organization.id, { user }, false);
      setName('');
      setEmail('');
    } else updateFormError(errors);
  };

  return (
    <form
      id="add-item-input"
      className="form-inline add-user-input row"
      onSubmit={(e) => {
        handleSubmit(e);
        nameInput.current.focus();
      }}
    >
      <div className={`input-holder ${errors?.name ? 'has-error' : ''}`}>
        <input
          id="member-name"
          type="text"
          value={name}
          ref={nameInput}
          onChange={handleNameChange}
          placeholder={errors?.name ? errors.name : 'Full Name'}
        />
      </div>
      <div className={`input-holder ${errors?.email ? 'has-error' : ''}`}>
        <input
          id="member-email"
          type="text"
          value={email}
          onChange={handleEmailChange}
          placeholder={errors?.email ? errors.email : 'email@yourco.com'}
        />
      </div>
      <button
        type="submit"
        id="quick-add-member"
        className="btn btn-xs add-user"
      >
        <strong>ADD USER</strong>
      </button>
    </form>
  );
};

AddUser.propTypes = {
  organization: PropTypes.object,
  formError: PropTypes.object
};

const mapStateToProps = (state) => ({
  formError: state.userReducer.formError || { errors: {} },
  teams: state.teamReducer.teams
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ createUser, updateFormError }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddUser)
);
